<template>
  <div
    class="tab-pane fade in"
    :class="{ active: vx_activeTab === 'reserveAfter' }"
    role="tabpanel"
  >
    <div class="table-responsive">
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings fontSize16">
            <th
              v-for="head in HEAD"
              :key="head.title"
              class="column-title word_center"
              :width="head.width"
            >
              {{ head.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(row, idx) in vx_list">
            <tr
              v-if="vx_list.length > 0"
              :key="row.id"
              :class="{ even: idx % 2 == 0, odd: idx % 2 != 0 }"
              class="text_hailing fontSize16"
              style="color: #000000"
            >
              <td class="word_center">
                {{
                  (vx_reserveAfterPaging.currentPage - 1) *
                    vx_reserveAfterPaging.npp +
                  (idx + 1)
                }}
              </td>
              <td class="word_center">{{ row.createdAt }}</td>
              <td class="word_center">{{ row.passengerPhone }}</td>
              <td class="word_center">{{ row.reservationTime }}</td>
              <td class="word_center">{{ row.customerServiceName }}</td>
              <td class="word_left">{{ row.onLocation }}</td>
              <th class="word_center">{{ row.passengerNote }}</th>
              <th class="word_center">{{ row.cars }}輛</th>
              <td
                class="word_center"
                :class="[
                  row.result === '未派遣' ? 'red_textcolor' : 'text_hailing',
                ]"
              >
                {{ row.result }}
              </td>
              <td class="word_center">
                {{ row.remindMinute }}分
                <el-button size="small" @click="onRecord(row.id)">
                  活動紀錄
                </el-button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <!--頁籤-->
      <el-row>
        <el-col :offset="10">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="onPageChange"
            :current-page="vx_reserveAfterPaging.currentPage"
            :page-count="vx_reserveAfterPaging.totalPages"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { reserveAfter } from '@/constants/tableHead'

export default {
  computed: {
    ...mapState('transaction', {
      vx_activeTab: 'activeTab',
      vx_list: 'reserveAfterList',
      vx_reserveAfterPaging: 'reserveAfterPaging',
    }),
  },
  methods: {
    ...mapMutations('transaction', {
      vx_setReserveAfterPagingCurrentPage: 'setReserveAfterPagingCurrentPage',
    }),
    ...mapActions('transaction', {
      vx_fetchList: 'fetchList',
    }),
    onRecord(id) {
      this.$router.push({
        name: 'activityRecord',
        query: { id: id, type: '後派單派遣' },
      })
    },
    onPageChange(page) {
      this.vx_setReserveAfterPagingCurrentPage(page)
      this.vx_fetchList()
    },
  },
  created() {
    this.HEAD = reserveAfter
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/transaction/components/ReserveAfter.vue